// Import Swiper and modules
import Swiper from "swiper/bundle";

export const featuredProducts = () => {
  const $featuredProductsSections = document.querySelectorAll(
    "section.featured-products"
  );
  if ($featuredProductsSections) {
    $featuredProductsSections.forEach(($featuredProducts) => {
      const $infoNav = $featuredProducts.querySelector(".info__nav");

      const $contentsSwiper = $featuredProducts.querySelector(
        ".contents__swiper.swiper"
      );
      if ($contentsSwiper) {
        const slidesToShow = $contentsSwiper.dataset.slidesToShow
          ? parseInt($contentsSwiper.dataset.slidesToShow)
          : 0;

        const slidesToShowTablet = slidesToShowTablet
          ? Math.ceil(slidesToShow / 2)
          : 2.4;
        const slidesToShowDesktop = slidesToShow ? slidesToShow : 3.6;

        const swiperConfig = {
          direction: "horizontal",
          speed: 1000,
          slidesPerView: 1.1,
          slidesPerGroup: 1,
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: slidesToShowTablet,
              slidesPerGroup: 1,
              slidesPerGroupAuto: true,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: slidesToShowDesktop,
              slidesPerGroup: 1,
              slidesPerGroupAuto: true,
              spaceBetween: 32,
            },
          },
        };

        if ($infoNav) {
          const $infoNavButtonPrev = $infoNav.querySelector(
            ".nav__button.nav__button--prev"
          );
          const $infoNavButtonNext = $infoNav.querySelector(
            ".nav__button.nav__button--next"
          );
          swiperConfig.navigation = {
            disabledClass: "nav__button--disabled",
            prevEl: $infoNavButtonPrev,
            nextEl: $infoNavButtonNext,
          };
        }
        const swiperObject = new Swiper($contentsSwiper, swiperConfig);
      }
    });
  }
};

export default featuredProducts;
